import { Button } from "@fluentui/react-components";
import { Options20Regular } from "@fluentui/react-icons";
import { useIntl } from "react-intl";
import TooltipWithMount from "@/components/atoms/tooltipWithMount/TooltipWithMount";
import { useInteractionStyle } from "@/components/organisms/interaction/style";
import { useStyle as useSupervisorStyle } from "@/components/organisms/supervisor/style";
import { AdvancedFilterButtonProps } from "./types";

export const AdvancedFilterButton = (
	props: AdvancedFilterButtonProps
): JSX.Element => {
	const { count, onClick } = props;
	const intl = useIntl();
	const classes = useSupervisorStyle();
	const interactionClasses = useInteractionStyle();

	const label = intl.formatMessage({ id: "Contacts.AdvancedFilter.Tooltip" });

	return (
		<TooltipWithMount content={label} relationship="label">
			{count > 0 ? (
				<Button
					shape="circular"
					aria-label={label}
					onClick={onClick}
					className={interactionClasses.filterButton}
				>
					<div className={interactionClasses.filterFontWeight}>{count}</div>
					<Options20Regular className={interactionClasses.filterButtonIcon} />
				</Button>
			) : (
				<Button
					appearance="transparent"
					aria-label={label}
					icon={<Options20Regular />}
					onClick={onClick}
					className={classes.filterTrigger}
				/>
			)}
		</TooltipWithMount>
	);
};
